const Cang= {
    namespaced:true,
    state:{
        weather:''
    },
    mutations:{
        setWeather(state,data){
            console.log(data);
            state.weather = data
        }
    },
    
    getters:{

    },
    actions:{

    },
}
export default Cang